import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "page"];

  static values = {
    activeLinkClasses: String,
    activeIconClasses: String,
    inactiveLinkClasses: String,
    inactiveIconClasses: String,
  };

  connect() {
    const hash = window.location.hash.slice(1);
    const target = hash
      ? this.menuTargets.find((m) => m.dataset.settingsIdParam === hash)
      : null;
    this.refreshLinkStyles(target || this.menuTargets[0]);
    if (target) this.changeTab(hash);
  }

  change(event) {
    event.preventDefault();
    const activeTab = event.params.id;
    this.activeTab = activeTab;
    this.refreshLinkStyles(event.target);
    this.changeTab(event.params.id);
  }

  refreshLinkStyles(activeTab) {
    const activeClasses = this.activeLinkClassesValue.split(" ");
    const inactiveClasses = this.inactiveLinkClassesValue.split(" ");
    this.menuTargets.forEach((menu) => {
      menu.classList.remove(...activeClasses);
      menu.classList.add(...inactiveClasses);
    });
    activeTab.classList.remove(...inactiveClasses);
    activeTab.classList.add(...activeClasses);
    this.refreshIconStyles(activeTab.querySelector("svg"));
  }

  refreshIconStyles(activeIcon) {
    const activeClasses = this.activeIconClassesValue.split(" ");
    const inactiveClasses = this.inactiveIconClassesValue.split(" ");
    this.menuTargets.forEach((menu) => {
      const icon = menu.querySelector("svg");
      icon.classList.remove(...activeClasses);
      icon.classList.add(...inactiveClasses);
    });
    activeIcon.classList.remove(...inactiveClasses);
    activeIcon.classList.add(...activeClasses);
  }

  changeTab(id) {
    console.log("Changing page to ", id);
    const pageToActivate = document.querySelector("#" + id);
    if (pageToActivate == null) {
      return;
    }
    this.pageTargets.forEach((page) => page.classList.add("hidden"));
    pageToActivate.classList.remove("hidden");
  }
}
